import relicsIconPng from "../assets/RelicsIcon.png";

import { createBitmapIcon } from "./createBitmapIcon";

export const RelicsIcon = createBitmapIcon({
  alt: "Relics",
  displayName: "RelicsIcon",
  src: relicsIconPng,
});
